import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import CustomButton from "../other/common/CustomButton";
import introducingImg from "../../assets/images/webp/other/introducing.webp";
import mindIsKingImg from "../../assets/images/webp/other/mind-is-king-img.webp";

const Hero = () => {
  return (
    <>
      <div className=" bg-[#EAF3EE] px-4">
        <div className="flex max-md:flex-col max-md:gap-10 items-center max-w-[1140px] mx-auto pt-[87px] pb-[121px] max-xl:pb-24 max-lg:py-16 max-md:py-12 max-sm:py-10">
          <div className="w-6/12 max-md:w-full relative">
            <BlueHeading
              text="Mindset is Power"
              color="blue-400"
              bgColor="[#2920D2]"
            />
            <h1 className="leading-[120%] font-bold ff-jakarta text-6xl max-xl:text-5xl max-lg:text-4xl text-[#001A3D] max-w-[400px]">
              Mind is King: Set Your Thermostat
            </h1>
            <p className="text-[#3B3B3B] font-normal text-base leading-[150%] pt-4">
              A powerful mental blueprint by Deepak Sharma
            </p>
            <CustomButton text="Buy the Book" myClass="mt-10 max-md:mt-6" />
            <img
              src={introducingImg}
              alt="intro"
              width={144}
              height={144}
              className="w-full max-w-[144px] pointer-events-none absolute left-[49%] bottom-[-90px] max-lg:bottom-[-70px] max-lg:max-w-[100px] max-md:hidden"
            />
          </div>
          <div className="w-6/12 max-md:w-full">
            <img
              src={mindIsKingImg}
              alt="mind-img"
              width={627}
              height={452}
              className="w-full max-w-[627px] pointer-events-none h-[452px] max-lg:h-full max-xl:object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
